import axios, { API_URL } from './BaseService';

export async function huntCryptoRadar(refresh = false) {
    const response = await axios.get(`${API_URL}/crypto-radar`, {
        params: refresh ? { refresh: 1 } : {}
    });
    return response.data;
}
